/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import GenericMessage from 'src/components/generic-message';

export const CenteredGenericMessage = styled(GenericMessage)({
  margin: 'auto',
  width: '100%',
  boxSizing: 'border-box',
});
